import Wiki from '@/views/Wiki/Index'
import WikiWiki from '@/views/Wiki/Wiki/Index'
import WikiWikiEntry from '@/views/Wiki/Wiki/Entry'

export default [
    {
        path: '/wiki',
        name: 'wiki',
        component: Wiki,
        meta: {
            title: 'Wiki',
            menuRendered: true,
            menuTitle: 'Wiki',
            permission: 'wiki',
            icon: 'mdi-wikipedia'
        },
        redirect: { name: 'wikiWiki' },
        children: [
            {
                path: '/wiki/wiki',
                name: 'wikiWiki',
                component: WikiWiki,
                meta: {
                    title: 'Wiki',
                    menuTitle: 'Wiki',
                    requiresAuth: true,
                    permission: 'wiki',
                },
            },
            {
                path: '/wiki/wiki/:id',
                name: 'wikiWikiEntry',
                component: WikiWikiEntry,
                meta: {
                    title: 'Wiki / Wpis',
                    requiresAuth: true,
                    permission:  'wiki'
                },
            },
        ],
    },
]